import { render, staticRenderFns } from "./DebugHeaderComponent.vue?vue&type=template&id=0c23f476&scoped=true&"
import script from "./DebugHeaderComponent.vue?vue&type=script&lang=ts&"
export * from "./DebugHeaderComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c23f476",
  null
  
)

export default component.exports